import { useState, cloneElement, useMemo } from "react";
import { Pressable } from "react-native";
import styles from "./styles";
import ForgotPasswordPhoneVerification from "../../../../Diathrive/src/containers/ForgotPasswordPhoneVerification";
import OnBoardingExperience from "../../../../Diathrive/src/containers/OnBoardingExperience";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import LogoHeader from "../../components/elements/LogoHeader";
import { useNavigate } from "react-router-dom";
import PasswordRecovery from "../../../../Diathrive/src/containers/PasswordRecovery";
import Text from "../../../../Diathrive/src/components/elements/Text";
import MobileAppStoreLinks from "../../components/elements/MobileAppStoreLinks";
import CommonStyles from "../../../../Diathrive/src/utils/CommonStyles";

export const StepComponent = ({
  navigation,
  currentStep = 1,
  moveToNextStep,
  testIdScreen,
  authCredentials,
  setAuthCredentials,
}) => {
  let comp;
  switch (currentStep) {
    case 1:
      comp = <ForgotPasswordPhoneVerification />;
      break;
    case 2:
      comp = <PasswordRecovery />;
      break;
  }
  const currentStepComponent = cloneElement(comp, {
    navigation,
    moveToNextStep,
    authCredentials,
    setAuthCredentials,
    testIdScreen,
  });

  return currentStepComponent;
};

export default function ForgotPassword() {
  let navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [authCredentials, setAuthCredentials] = useState({});
  const testIdScreen = useMemo(() => {
    let id;
    switch (step) {
      case 1:
        id = "ForgotPasswordPhoneVerification";
        break;
      case 2:
        id = "PasswordRecovery";
        break;
    }
    return id;
  }, [step]);
  return (
    <>
      <div
        data-testid={tID("ForgotPasswordFlow-div-Container")}
        style={styles.container}
      >
        <div style={styles.uniqueIdForm}>
          <LogoHeader />
          <Pressable
            style={styles.alignLeft}
            onPress={() => {
              navigate("/login");
            }}
            testID={tID("ForgotPassword-Pressable-BackToSignIn")}
          >
            <Text variation="Text1SemiBold">
              {"<  "}
              <Text variation="Body2">Back to Sign-In</Text>
            </Text>
          </Pressable>
          <div style={styles.formContainer}>
            <StepComponent
              navigation={navigate}
              currentStep={step}
              moveToNextStep={setStep}
              testIdScreen={testIdScreen}
              authCredentials={authCredentials}
              setAuthCredentials={setAuthCredentials}
            />
          </div>
          <MobileAppStoreLinks
            containerStyle={CommonStyles.mb_52}
            testIdScreenName="ForgotPassword"
          />
        </div>
        <div style={styles.previewImage}>
          <OnBoardingExperience />
        </div>
      </div>
    </>
  );
}
